import { render, staticRenderFns } from "./SloganView.vue?vue&type=template&id=4a98dff2&scoped=true&"
import script from "./SloganView.vue?vue&type=script&lang=ts&"
export * from "./SloganView.vue?vue&type=script&lang=ts&"
import style0 from "./SloganView.css?vue&type=style&index=0&id=4a98dff2&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a98dff2",
  null
  
)

export default component.exports